<template>
  <v-container fluid>
    <div v-for="item in options" :key="item.text" class="pa-0 ma-0">
      <v-row>
        <v-col cols="6" class="ma-0 pa-0">
          <v-checkbox
            hide-details
            class="pa-0 ma-0"
            v-model="selected"
            :label="`${item.text}${item.hasPrice ? ' ($' + item.price + ')' : ''}`"
            :value="item"
            @change="changed"
            align-center
          >
            <template v-slot:label>
              <v-layout align-center>
                <v-flex>
                  <img
                    class="pa-0 ma-1"
                    v-if="field.data.imageMode == IMAGE_MODES.ICONS && item.imgId"
                    :src="getImgFromBuffer(images[item.imgId])"
                    style="max-width: 50px; max-height: 50px"
                  />
                </v-flex>
                <v-flex class="pa-0 ma-0">{{
                  `${item.text}${item.hasPrice ? ' ($' + item.price + ')' : ''}`
                }}</v-flex>
              </v-layout>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="6" classs="pa-0 ma-0">
          <v-text-field
            hide-details
            class="ma-0 pa-0"
            type="number"
            label="Number of products"
            min="1"
            v-if="field.data.countable && selected.includes(item) && item != NO_ITEM"
            v-model="item.count"
            @click="changed"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IMAGE_MODES from '@/constants/imageModes'
import NO_ITEM from '@/constants/noItem'
export default {
  name: 'SelectMultipleTextOptions',
  data() {
    return {
      valid: false,
      selected: [],
      options: [],
      IMAGE_MODES,
      NO_ITEM
    }
  },
  created() {
    if (this.options.length == 0) {
      this.options = this.field.data.attrs.options
      if (this.field.data.countable) {
        this.options.forEach(item => {
          if (!item.count) item.count = 1
        })
      }
      if (!this.field.data.required && this.options[0] != this.NO_ITEM) {
        this.options.unshift(this.NO_ITEM)
      }
      if (this.field.data.imageMode == IMAGE_MODES.ICONS) {
        this.loadThumbnails(this.field)
      }
    }
    if (this.defaultValue) {
      this.selected = this.defaultValue
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: Array
    }
  },
  computed: {
    images() {
      return this.allImages()
    }
  },
  methods: {
    ...mapActions('images', ['loadThumbnails']),
    ...mapGetters('images', ['allImages']),
    getImgFromBuffer(buffer) {
      try {
        return 'data:image/jpg;base64, ' + buffer.toString('base64')
      } catch {
        return 'img/no_image.png'
      }
    },
    getFieldRules() {
      const rulesF = []
      if (this.field.data.required) {
        rulesF.push(value => (value && value.length > 0) || 'Required.')
      }
      return rulesF
    },
    getValueObj(item) {
      const obj = { text: item.text }
      if (item.hasPrice) obj.price = item.price
      if (this.field.data.countable) obj.count = item.count
      return obj
    },
    changed() {
      if (!this.field.required && this.selected.length > 1) {
        if (this.selected[this.selected.length - 1] == this.NO_ITEM) {
          this.selected.splice(0, this.selected.length - 1)
        } else if (this.selected[0] == this.NO_ITEM) this.selected.splice(0, 1)
      }

      this.onChange({
        id: this.field._id,
        value: this.selected.map(item => this.getValueObj(item)),
        rawValues: this.selected,
        ...this.getValidationResults()
      })
    },
    getValidationResults() {
      return this.selected.length > 0
        ? { errMsg: null, valid: true }
        : { errMsg: 'Required', valid: false }
    }
  }
}
</script>

<style lang="scss" scoped></style>
